module.exports = __webpack_public_path__ + "static/media/680.8707fe0b.webp";